/*
 * @Author: your name
 * @Date: 2020-12-02 16:22:04
 * @LastEditTime: 2020-12-11 08:58:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\HUD.js
 */
/**
 * @Description HUD类
 * @Author iCEA
 * @Date 2020-10-29
 * @Version 1.0
 * @todo 1、注册进Cursor和MobileTouch的两个listener里调用，就是改样式。
 */
import TWEEN from 'tween.js'
import { InputBase } from './Input/InputBase'
import { waitFor } from './Utils'

export class HUD {
  constructor () {
    /**
     * @type {Element} hud的dom元素
     */
    this.hud = document.getElementsByClassName('hud-container')[0]
    this.hud.style.opacity = '1'
    /**
     * @type {boolean} 鼠标是否按下
     */
    this.mouseDown = false
    /**
     * @type {TWEEN} 隐藏hud动画
     */
    this.hidehud = null
    /**
     * @type {TWEEN} 显现HUD动画
     */
    this.showhud = null
    /**
     * @type {Boolean} HUD显示标志
     */
    this.showS = false
    /**
     * @type {Boolean} 确认VR模式
     */
    this.checkVR = false
  }

  /**
   * 以输入组件初始化
   * @param {InputBase[]} inputs 输入组件
   */
  init (inputs) {
    for (const i of inputs) {
      if (i.hideHUDListener) {
        i.hideHUDListener.add(this.hide.bind(this))
        i.showHUDListener.add(this.show.bind(this))
      }
    }
  }

  /**
   * 隐藏hud
   */
  async hide () {
    this.mouseDown = true // 鼠标按下

    if (this.showS || this.hud.style.opacity === '1' || this.showhud) { // 如果已进入动画函数（正在显示）则打断，执行隐藏动画，另一个可能是完全显现时则执行
      this.showS = false // 打断情况一，还未执行动画，还在等500ms，则置false以终止后续步骤
      TWEEN.remove(this.showhud) // 打断情况二，已经在执行动画，则打断动画
      this.showhud = null
      await this.hideHUD() // 正在隐藏
      // 已隐藏
      if (!this.mouseDown) {
        await this.showHUD()
      }
    }
  }

  /**
   * 显现hud
   */
  async show () {
    if (this.checkVR) return
    this.mouseDown = false // 鼠标抬起
    if (this.hud.style.display === 'none') {
      await this.showHUD() // 仅有当display属性为none时（动画完成标志）播放此显现动画
      // 已显现
    }
  }

  /**
   * [tween] 隐藏hud动画
   */
  async hideHUD () {
    const self = this
    const a = {
      opacity: self.hud.style.opacity
    }
    self.hidehud = new TWEEN.Tween(a)
    self.hidehud.to({ opacity: self.hud.style.opacity - 1 }, 500)
    self.hidehud.onUpdate(() => {
      self.hud.style.opacity = a.opacity > 0 ? a.opacity : 0
    })
    return new Promise((resolve, reject) => {
      self.hidehud.onComplete(() => {
        self.hud.style.display = 'none'
        self.hidehud = null
        resolve()
      })
      self.hidehud.start()
    })
  }

  /**
   * [tween] 显现hud动画
   */
  async showHUD () {
    const self = this
    self.showS = true
    self.hud.style.display = 'block'
    await waitFor(500)
    if (!self.showS) return // 如果此时在等待 且还未进入动画 则可以通过此临时打断，如果已经进入动画则通过动画指针打断
    const a = {
      opacity: self.hud.style.opacity
    }
    self.showhud = new TWEEN.Tween(a)
    self.showhud.to({ opacity: 1 }, 500)
    self.showhud.onUpdate(() => {
      self.hud.style.opacity = a.opacity
    })
    return new Promise((resolve, reject) => {
      self.showhud.onComplete(() => {
        self.showS = false
        self.showhud = null
        resolve()
      })
      self.showhud.delay(500)
      self.showhud.start()
    })
  }
}
